app = angular.module("seismology")

app.controller "ConnectCtrl", ($scope, $state, $window, $mdDialog, PostFactory, Users, CurrentUser, $firebaseObject, CLOUDINARY_CONFIGS) ->
  
  $scope.IMAGE_BASE_URL = CLOUDINARY_CONFIGS.IMAGE_BASE_URL
  $scope.currentUser = CurrentUser.get()    
  $scope.moment = $window.moment
  $scope.objSize = (obj)->
    return 0 unless obj
    Object.keys(obj).length
    
  $scope.posts = PostFactory.getScroll()
  $scope.posts.$loaded ->
    for p in $scope.posts
      p.visibleCommentCount = 3;
  $scope.loadMore = (count=10)->
    $scope.posts.$ref().scroll.next(count)
  $scope.loadMore()
      
  $scope.users = Users

  $scope.showMoreComments = (post) ->
    post.visibleCommentCount ||= 3
    post.visibleCommentCount += 3
    
  $scope.openPhotoModal = (id) ->
    $mdDialog.show
      controller: ($scope) -> $scope.id = id
      templateUrl: 'templates/dialogs/image.html'
      parent: angular.element(document.body)
      clickOutsideToClose:true

  $scope.openThumbnailModal = (img) ->
    $mdDialog.show
      controller: ($scope) ->
        $scope.img = img
        console.log img
      templateUrl: 'templates/dialogs/thumbnail.html'
      parent: angular.element(document.body)
      clickOutsideToClose:true

  $scope.sendComment = (post)->
    return unless post.newComment.text.length>0
    post.addComment(post.newComment).then ->
      post.newComment = {}
  $scope.selectCommentFiles = (files, post)->
    comment = post.newComment
    comment.images ||= []
    for file in files
      if comment.images.length >= 2
        return alert '添付できる写真は2枚までです。'
      comment.images.push(file)

  $scope.removePost = (post, ev) ->
    return unless post.uid is $scope.currentUser.$id
    confirm = $mdDialog.confirm()
      .title('投稿の削除')
      .textContent('この投稿を削除します。よろしいですか？')
      .ariaLabel('removing post')
      .targetEvent(ev)
      .ok('削除')
      .cancel('キャンセル')
    $mdDialog.show(confirm).then ->
      post.$remove()

  $scope.removeComment = (post, key, ev) ->
    confirm = $mdDialog.confirm()
      .title('コメントの削除')
      .textContent('このコメントを削除します。よろしいですか？')
      .ariaLabel('removing comment')
      .targetEvent(ev)
      .ok('削除')
      .cancel('キャンセル')
    $mdDialog.show(confirm).then ->
      post.removeComment(key)

  # 新規投稿
  $scope.initNewPost = ->
    $scope.newPost = {
      text: "", images: [], category: $scope.postCategories[0].value
    }
    $scope.imagesToUpload = []
    $window.post = $scope.newPost
    $scope.uploading = false
  $scope.postCategories = [
    {name: '質問', value: 'question'},
    {name: '情報求ム！', value: 'seeking'},
    {name: '資料紹介', value: 'showcase'}
    ]    
  
  $scope.selectFiles = (files) ->
    for file in files
      if $scope.imagesToUpload.length >= 4
        return alert '添付できる写真は4枚までです。'      
      $scope.imagesToUpload.push(file)
    console.log files
  $scope.removeImage = (index) ->
    $scope.imagesToUpload.splice(index, 1)
  $scope.submitPost = ->
    $scope.uploading = true
    PostFactory.add($scope.newPost, $scope.imagesToUpload).then ->
      $scope.initNewPost()

  $scope.initNewPost()

app.controller "PostCtrl", ($scope, $stateParams,$mdDialog, $window, Users, CLOUDINARY_CONFIGS, post)->
  $scope.IMAGE_BASE_URL = CLOUDINARY_CONFIGS.IMAGE_BASE_URL
  post_id = $stateParams.post_id
  $scope.isSinglePage = true
  $scope.post = post
  $scope.users = Users
  $scope.moment = $window.moment

  $scope.sendComment = ->
    return unless post.newComment.text.length>0
    $scope.post.addComment(post.newComment).then ->
      $scope.post.newComment = {}
  $scope.selectCommentFiles = (files, post)->
    comment = $scope.post.newComment
    comment.images ||= []
    for file in files
      if comment.images.length >= 2
        return alert '添付できる写真は2枚までです。'
      comment.images.push(file)
  $scope.removeComment = (post, key, ev) ->
    confirm = $mdDialog.confirm()
      .title('コメントの削除')
      .textContent('このコメントを削除します。よろしいですか？')
      .ariaLabel('removing comment')
      .targetEvent(ev)
      .ok('削除')
      .cancel('キャンセル')
    $mdDialog.show(confirm).then ->
      $scope.post.removeComment(key)

  $scope.openPhotoModal = (id) ->
    $mdDialog.show
      controller: ($scope) -> $scope.id = id
      templateUrl: 'templates/dialogs/image.html'
      parent: angular.element(document.body)
      clickOutsideToClose:true
      
    
app.controller "ProfileDialogCtrl", ($scope, $state, $mdDialog, $window, PostFactory, user) ->
  console.log user
  $scope.user = user
  $scope.moment = $window.moment
  $scope.close = -> $mdDialog.cancel()
  $scope.posts = PostFactory.getListByUid(user.$id)
  $scope.moveToPost = (post) ->
    $state.go("dashboard.post", post_id: post.$id)
    $mdDialog.cancel()
  
app.controller "LikesDialogCtrl", ($scope, $state, $mdDialog, $window, Users, likes) ->
  $scope.Users = Users
  $scope.likes = likes
  $scope.close = -> $mdDialog.cancel()



// WEBPACK FOOTER //
// ./app/controllers/connect_controllers.coffee